
<script>
import Grid from "src/components/Shared/Grid";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "Jobs",
  components: {
    Grid,
  },
  created(){
    // TODO
    // this.fetchSearchOrderTypes()
  },
  data() {
    return {
      module: this.$route.meta.module,
      filterable: true,
      pagination: {
        rowsNumber: 0,
        rowsPerPage: 50,
        page: 1,
        descending: true,
        sortBy: "DATE_CREATED"
      },
      columnOptions: [
        {
          field: "ROSTER_JOB_ID",
          name: "ROSTER_JOB_ID",
          label: "Job ID",
          sortable: true,
          filterable: true,
          type: "string",
          align: "left",
          width: "90px"
        },        
        {
          field: "DATE_CREATED",
          name: "DATE_CREATED",
          label: "Date Started",
          sortable: true,
          filterable: false,
          type: "date",
          align: "left",
        },
        {
          field: "statusText",
          name: "status",
          label: "Status",
          sortable: true,
          filterable: true,
          type: "string",
          align: "left",
        },
        {
          field: "approvalStatus",
          name: "approval_status",
          label: "Approval Status",
          sortable: false,
          filterable: false,
          type: "string",
          align: "left",
        },
        {
          field: "USER",
          align: "left",
          name: "USER",
          label: "Started By",
          sortable: true,
          filterable: true,
          type: "string"
        },
        {
          field: "CLASS_ID",
          name: "class_id",
          label: "Related Class ID",
          sortable: true,
          filterable: true,
          type: "string",
          align: "left",
          width: "90px",
          clickable: true,
        },
      ]
    };
  },
  computed: {
    ...mapState('jobs', {
      list: state => state.list,
      loading: state => state.loading,
      searchFields: state => state.searchFields,
    }),
    ...mapGetters('jobs', [
      'jobList',
      'rosterStatusOptions',
      'approvalStatusOptions',
    ]),
  },
  methods: {
    ...mapActions('jobs', [
      'fetchAll',
    ]),
    ...mapActions('classes', [
      'one',
    ]),
    ...mapMutations('jobs', [
      'setJobModalOpen',
      'setCurrentJob',
      'clearSearchFields',
    ]),
    formatUserInitials(user) {
      return user.USER_FIRST_NAME[0] + user.USER_LAST_NAME[0];
    },
    openJobModal(job) {
      this.setCurrentJob(job)
      this.setJobModalOpen(true)
    },
    onColumnClick({ row, col, value, name }) {
      switch (name) {
        case 'class_id': {
          this.one({
            id: value,
            mode: "edit"
          })
        }
      }
    },
    fetchAndClear(){
      this.clearSearchFields()
      this.search()
    },
    search(){
      this.$root.$emit('refreshGrid:jobsGrid')
    }
  }
};
</script>

<template>
  <q-page id="jobs-page" class="stretch-grid has-search" color="white">
    <q-collapsible class="search-box" collapse-icon="fa fa-angle-down">
      <template slot="header">
        <h5 style="padding: 12px 0px 12px 13px;width: 100%;">
          <q-icon
            name="fa fa-search"
            color="primary"
            style="padding:0 5px 3px"
          /> Jobs Search
        </h5>
      </template>
      <form v-on:submit.prevent="">
        <div class="sl-row no-margin">
          <div
            class="sl-col-4"
          >
            <q-input
              float-label="Roster Job ID"
              v-model="searchFields.ROSTER_JOB_ID"
            />
          </div>

          <div class="sl-col-4">
              <q-field>
                <q-select
                    float-label="Roster Job Status"
                    v-model="searchFields.ROSTER_JOB_STATUS"
                    :options="rosterStatusOptions"
                />
            </q-field>
          </div>
          <div class="sl-col-4">
            <q-input float-label="Class ID" v-model="searchFields.CLASS_ID" />
          </div>
        </div>
        <div class="sl-row no-margin">
          <div class="sl-col-4">
              <q-field>
                <q-select
                    float-label="Approval Status"
                    v-model="searchFields.LK_CLASS_APPROVAL_STATUS_ID"
                    :options="approvalStatusOptions"
                />
            </q-field>
          </div>
        </div>

        <q-toolbar color="white" style="padding-right:60px">
          <q-toolbar-title></q-toolbar-title>
          <q-btn color="secondary" label="Clear" outline size="sm" type="reset" style="margin-right:5px" @click="fetchAndClear"/>
          <q-btn color="primary" label="Search" size="sm" type="submit" @click="search()" />
        </q-toolbar>
      </form>
    </q-collapsible>
    <!-- content -->
    <Grid
      id="jobsGrid"
      class="fit"
      :module="module"
      :data="jobList"
      :columns="columnOptions"
      :pagination="pagination"
      :onRequest="fetchAll"
      :onLaunch="openJobModal"
      :loading="loading"
      :filterable="filterable"
      :onColumnClick="onColumnClick"
    >
      <template slot="col-item-status" slot-scope="props">
        <div
          style="display:inline-block;margin-left: 10px;border-radius:30px"
          class="label"
          :class="{
                  'blue': props.value == 'Processing',
                  'purple': props.value == 'Ready for Review',
                  'yellow': props.value == 'In Review',
                  'green' : props.value == 'Completed',
                  'red' : props.value == 'Error'
              }"
        >{{props.value || '?'}}</div>
      </template>
      <template slot="col-item-user" slot-scope="props">
        <div
          class="label green round small"
          style="font-size: 11px;padding: 6px 0px;margin-right: 5px"
        >{{formatUserInitials(props.value)}}</div>
        {{props.value.USER_FIRST_NAME}} {{props.value.USER_LAST_NAME}}
      </template>
      <template slot="col-item-approval_status" slot-scope="props">
        <div
          v-if="props.value"
          style="display:inline-block;margin-left: 10px;border-radius:30px;text-transform:capitalize"
          class="label small"
          :class="{
                  'blue': props.value == 'SUBMITTED' || props.value == 'RESUBMITTED',
                  'green': props.value == 'APPROVED',
                  'red': props.value == 'REJECTED',
                  'yellow': props.value == 'EXPIRED',
                  'grey': props.value == 'NOT SUBMITTED',
                  'purple': props.value == 'COMPLETED'
              }"
        >{{props.value.toLowerCase()}}</div>
      </template>
    </Grid>
  </q-page>
</template>


<style lang="stylus">

// #order-header {
// min-height: 120px
// }
// #order-body {

// }
#jobs-page {
  display: flex;
}
</style>
